'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.field = exports.rules = exports.form = undefined;

var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);

var _form = require('./form');

Object.defineProperty(exports, 'form', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_form).default;
  }
});

var _rules = require('./rules');

Object.defineProperty(exports, 'rules', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_rules).default;
  }
});
Object.defineProperty(exports, 'field', {
  enumerable: true,
  get: function get() {
    return _form.computedField;
  }
});

var _cerebral = require('cerebral');

var _tags = require('cerebral/tags');

var _form2 = _interopRequireDefault(_form);

var _rules2 = _interopRequireDefault(_rules);

var _resetForm = require('./helpers/resetForm');

var _resetForm2 = _interopRequireDefault(_resetForm);

var _formToJSON = require('./helpers/formToJSON');

var _formToJSON2 = _interopRequireDefault(_formToJSON);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function FormsProvider() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.rules) {
    Object.assign(_rules2.default, options.rules);
  }

  if (options.errorMessages) {
    _rules2.default._errorMessages = options.errorMessages;
  }

  return (0, _cerebral.Provider)({
    get: function get(path) {
      return this.context.resolve.value((0, _form2.default)((0, _tags.state)(_templateObject, path)));
    },
    reset: function reset(path) {
      this.context.state.set(path, (0, _resetForm2.default)(this.context.state.get(path)));
    },
    toJSON: function toJSON(path) {
      return (0, _formToJSON2.default)(this.context.state.get(path));
    },
    updateRules: function updateRules(newRules) {
      Object.assign(_rules2.default, newRules);
    },
    updateErrorMessages: function updateErrorMessages(errorMessages) {
      Object.assign(_rules2.default._errorMessages, errorMessages);
    }
  });
}

exports.default = FormsProvider;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/index.js
// module id = 116
// module chunks = 5